function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <g clipPath="url(#header-service-a)">
        <path
          fill="url(#header-service-b)"
          d="M18.464 6.36h-.163a8.956 8.956 0 0 0-1.98-2.987A8.956 8.956 0 0 0 9.968.741a8.957 8.957 0 0 0-6.355 2.632 8.957 8.957 0 0 0-1.98 2.987h-.065a.979.979 0 0 0-.979.98v2.662c0 .54.439.979.98.979h.92c.54 0 .979-.438.979-.979V7.339a.979.979 0 0 0-.587-.897 7.823 7.823 0 0 1 7.087-4.526c3.15 0 5.87 1.874 7.105 4.566a.979.979 0 0 0-.507.857v2.663c0 .54.438.979.98.979h.135a7.796 7.796 0 0 1-6.112 6.396 1.576 1.576 0 1 0-.315 1.247 8.94 8.94 0 0 0 5.205-2.68 8.938 8.938 0 0 0 2.422-5.055.979.979 0 0 0 .563-.887V7.339a.98.98 0 0 0-.979-.979Z"
        />
        <path
          fill="url(#header-service-c)"
          d="M16.154 9.65a6.109 6.109 0 1 0-12.217 0 6.109 6.109 0 0 0 12.217 0ZM7.03 11.098c0-.065.054-.117.12-.117h5.712c.066 0 .12.052.12.117a2.976 2.976 0 1 1-5.952 0Z"
        />
      </g>
      <defs>
        <linearGradient
          id="header-service-b"
          x1={2.353}
          x2={22.215}
          y1={1.783}
          y2={12.947}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2603E" />
          <stop offset={1} stopColor="#F38B2B" />
        </linearGradient>
        <linearGradient
          id="header-service-c"
          x1={5.08}
          x2={18.072}
          y1={4.23}
          y2={11.388}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2603E" />
          <stop offset={1} stopColor="#F38B2B" />
        </linearGradient>
        <clipPath id="header-service-a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
